import { render, staticRenderFns } from "./lottery-action.vue?vue&type=template&id=29fcf24c&scoped=true&"
import script from "./lottery-action.vue?vue&type=script&lang=js&"
export * from "./lottery-action.vue?vue&type=script&lang=js&"
import style0 from "./lottery-action.vue?vue&type=style&index=0&id=29fcf24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fcf24c",
  null
  
)

export default component.exports